import { render, staticRenderFns } from "./Syx.vue?vue&type=template&id=7aff1b19&scoped=true&"
import script from "./Syx.vue?vue&type=script&lang=js&"
export * from "./Syx.vue?vue&type=script&lang=js&"
import style0 from "./Syx.vue?vue&type=style&index=0&id=7aff1b19&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff1b19",
  null
  
)

export default component.exports